/**
 * Haptic feedback utility using navigator.vibrate where available.
 * Gracefully degrades to a no-op if unsupported or restricted.
 */
export type HapticType =
  | 'light'
  | 'medium'
  | 'heavy'
  | 'selection'
  | 'success'
  | 'warning'
  | 'error';

export function triggerHaptic(type: HapticType = 'light'): void {
  if (
    typeof window === 'undefined' ||
    typeof navigator === 'undefined' ||
    !navigator.vibrate
  ) {
    return;
  }

  try {
    switch (type) {
      case 'light':
      case 'selection':
        navigator.vibrate(10);
        break;
      case 'medium':
        navigator.vibrate(20);
        break;
      case 'heavy':
        navigator.vibrate(35);
        break;
      case 'success':
        navigator.vibrate([15, 50, 20]);
        break;
      case 'warning':
        navigator.vibrate([30, 60, 30]);
        break;
      case 'error':
        navigator.vibrate([50, 80, 50, 80, 50]);
        break;
    }
  } catch {
    // Vibration not allowed by user agent or document permissions
  }
}
